import axios from "axios";
import { adminApi } from "./adminClient";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ---------------------------------------------------------------------------
// Publiek: gepubliceerde nieuwsberichten
// ---------------------------------------------------------------------------
export const fetchPublishedNews = async ({ type } = {}) => {
  const params = {};
  if (type) params.type = type;
  const r = await axios.get(`${API}/news`, { params });
  return r.data;
};

export const fetchNewsBySlug = async (slug) => {
  const r = await axios.get(`${API}/news/${slug}`);
  return r.data;
};

// ---------------------------------------------------------------------------
// Admin CRUD
// ---------------------------------------------------------------------------
export const fetchAdminNews = async (params = {}) => {
  const r = await adminApi.get("/admin/news", { params });
  return r.data;
};

export const fetchAdminNewsPost = async (idOrSlug) => {
  const r = await adminApi.get(`/admin/news/${idOrSlug}`);
  return r.data;
};

export const createAdminNews = async (payload) => {
  const r = await adminApi.post("/admin/news", payload);
  return r.data;
};

export const updateAdminNews = async (idOrSlug, payload, { rename_slug } = {}) => {
  const r = await adminApi.put(`/admin/news/${idOrSlug}`, payload, {
    params: rename_slug ? { rename_slug: true } : {},
  });
  return r.data;
};

export const deleteAdminNews = async (idOrSlug) => {
  const r = await adminApi.delete(`/admin/news/${idOrSlug}`);
  return r.data;
};

export const uploadAdminNewsPhoto = async (idOrSlug, file) => {
  const form = new FormData();
  form.append("file", file);
  const r = await adminApi.post(`/admin/news/${idOrSlug}/photo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
};

// Voor inline plaatjes in de rich-text editor
export const uploadInlineNewsImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const r = await adminApi.post(`/admin/news/upload-inline-image`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data; // {ok, url}
};

export const TYPE_LABELS = {
  blog: "Blog",
  persbericht: "Persbericht",
};

export const STATUS_LABELS = {
  draft: "Concept",
  published: "Gepubliceerd",
};
